import React, { useState } from 'react';

interface SimpleDropdownProps {
  options: string[];
  onSelect: (value: string) => void;
  defaultValue?: string;
  placeholder?: string;
  width?: string;
}

const SimpleDropdown: React.FC<SimpleDropdownProps> = ({
  options,
  onSelect,
  defaultValue = '',
  placeholder = 'Select...',
  width = 'auto'
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(defaultValue);

  const handleSelect = (option: string) => {
    setSelectedValue(option);
    onSelect(option);
    setIsOpen(false);
  };

  return (
    <div className="simple-dropdown" style={{ width }}>
      <button
        type="button"
        className="simple-dropdown__button"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="simple-dropdown__text">{selectedValue || placeholder}</span>
        <svg 
          className={`simple-dropdown__arrow ${isOpen ? 'simple-dropdown__arrow--open' : ''}`} 
          fill="currentColor" 
          viewBox="0 0 20 20"
        >
          <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
        </svg>
      </button>
      
      {isOpen && (
        <div className="simple-dropdown__menu">
          {options.map((option, index) => (
            <button
              key={index}
              type="button"
              className="simple-dropdown__option"
              onClick={() => handleSelect(option)}
            >
              {option}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default SimpleDropdown;